import WGProfileDialog from './WGProfileDialog';

export default WGProfileDialog;
